// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import CartLinesDates, {
    CartLinesDatesPresentationProps,
    CartLinesDatesProps,
} from "@store/Library/Components/Cart/CartLinesDates";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productLineV2Props } from "@store/Themes/common/props/productLineV2";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductLineRequestedDatesProps {
    onChangeRequestedDate?: CartLinesDatesProps["deliveryDatesUpdatedHandler"];
}

export interface ProductLineRequestedDatesStyles {
    cartLinesDates?: CartLinesDatesPresentationProps;
}

const toggleLinkProps = (src?: IconPresentationProps["src"]): LinkPresentationProps => {
    return {
        icon: {
            position: "left",
            iconProps: {
                size: 21,
                src,
                css: css`
                    margin-right: ${pxToRem(6)};
                `,
            },
        },
        css: css`
            ${focusStyles(true)}
            width: 100%;
            padding: ${pxToRem(16, 24)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            transition: ${transitionHoverStyles("color")};

            &:hover {
                color: ${getColor("primary")};
                text-decoration: underline;
            }
        `,
    };
};

export const productLineRequestedDatesStyles: ProductLineRequestedDatesStyles = {
    cartLinesDates: {
        extendedStyles: {
            datePicker: { sizeVariant: "small" },
            poTextField: { sizeVariant: "small" },
        },
        overridedStyles: {
            wrapper: null as any,
            innerWrapper: {
                css: css`
                    ${breakpointValues(productLineV2Props.boxPaddingValues, [
                        "padding-right",
                        "padding-bottom",
                        "padding-left",
                    ])}
                `,
            },
            collapseLink: toggleLinkProps(Minus),
            expandLink: toggleLinkProps(Plus),
            linkAdd: linkGetActionLinkProps(Plus, "left", "1em", pxToRem(2)),
        },
    },
};

const styles = productLineRequestedDatesStyles;

const ProductLineRequestedDates: FC<ProductLineRequestedDatesProps> = ({ onChangeRequestedDate }) => {
    return (
        <CartLinesDates
            {...styles.cartLinesDates}
            deliveryDatesUpdatedHandler={onChangeRequestedDate}
            isProductLine
            enableCopyPaste
        />
    );
};

export default ProductLineRequestedDates;
